import { combineReducers } from 'redux';

import data from 'modules/messagingAccounts/reducers/data';
import ui from 'modules/messagingAccounts/reducers/ui';

const messagingAccounts = combineReducers({
  data,
  ui,
});

export type MessagingAccountsReducer = ReturnType<typeof messagingAccounts>;

export default messagingAccounts;
